/**
 * Showroom Filter App
 * Provides client-side search and filtering for virtual showroom displays
 */

import { createApp } from 'vue';
import ShowroomFilter from './components/ShowroomFilter.vue';

// Initialize Vue app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const appElement = document.getElementById('showroom-filter-app');

	if (appElement) {
		// Parse showroom data from data attribute
		const showroomsData = appElement.dataset.showrooms || '[]';
		const showrooms = JSON.parse(showroomsData);

		if (showrooms.length > 0) {
			const app = createApp(ShowroomFilter, {
				showrooms,
			});

			// Make WordPress data available to Vue
			app.config.globalProperties.$wordpress = {
				ajaxUrl: window.jaeckleData?.ajaxUrl || '/wp-admin/admin-ajax.php',
				nonce: window.jaeckleData?.nonce || '',
				siteUrl: window.jaeckleData?.siteUrl || '',
			};

			app.mount('#showroom-filter-app');
		}
	}
});
